/****************************************************
 *
 * config.js v2.00
 *
 * How to use:
 * import { Config } from '../config'
 * ...or:
 * import { Config } from 'src/ProjectName/config'
 *
 * @copyright Zooma 2017
 *
 */

const Breakpoints = {
  mobile          : 480,
  phablet         : 640,
  tablet          : 768,
  desktop         : 992,
  mediumDesktop   : 1170
}

const Localization = {
  replyTo         : 'Reply to',    // Reply to [name]
  formErrOccured  : 'One or more errors occurred',
  formErrCaptcha  : 'Please answer the CAPTCHA correctly'
}

const Brands = [
  {
      name    : 'Biolin Scientific Offices',
      key     : 'biolin_scientific'
  },
  {
      name    : 'Attension',
      key     : 'attension'
  },
  {
      name    : 'QSense',
      key     : 'qsense'
  },
  {
      name    : 'KSV NIMA',
      key     : 'ksv_nima'
  }
]

const VueApps = {
  filterMinChars      : 2,
  filterDebounceTime  : 450,
  fakeLoadTime        : 750, // Not sure why we have to wait before the page is ready, but it's the golden rule
  minLoadtime         : 500,
  enableAnimBodyClass : 'vue-animations',
  fakeLoading         : {
      enabled             : true,
      searchKeyDuration   : 50,   // Time after keyword search
      filterDuration      : 100,  // Time after selecting filter
      postDuration        : 200,  // Time after opening post
  }
}

// Sticky Nav -- used for Tile Nav, Events
const StickyNav = {
 selector            : '.StickyNav-wrapper',
 scrolledBodyClass   : 'sticky-nav-scrolled'
}

const Publications = {
  startYear: 1995
}

// Landing Page
const LandingPages = {
  enableFormReminder          : true, // Adds a sticky form reminder on smaller screens
      formReminderBreakpoint  : Breakpoints.tablet   // Needs to be set
}

// Post Body
const PostBody = {
  tableWrapperClass       : 'TableWrapper',
  disableTableOffsetClass : 'disable-offset',
  offsetTableColOffset    : 3 // Set TableWrapper on tables with column counts > this value
}

// Navigation Options
const Nav = {
  throttleTime        : 17,
  defaultStateClass   : 'is-defaultState',
}


const Config = {
  domain                      : 'biolinscientific.com', // TODO: A bit hacky, but for now it helps us differentiate external links
  webfonts                    : ['Roboto', 'Roboto Slab'], // ex ['Open Sans', ...]
  initiatedBodyClass          : 'initiated',
  enableTransitionsBodyClass  : 'transitions',
  scrolledBodyClass           : 'has-scrolled',
  scrolledMoreBodyClass       : 'has-scrolled-more',
  scrollingBodyClass          : 'scrolling',
  scrollingDownBodyClass      : 'scrolling-down',
  scrollingUpBodyClass        : 'scrolling-up',
  reachedBottomBodyClass      : 'reached-bottom',
  resizingBodyClass           : 'resizing',
  modalOpenedBodyClass        : 'modal-open',
  idleBodyClass               : 'idle',
  scrolledMoreDistance        : 540, // Distance to scroll before the scrolledMore class
  throttleTime                : 100,
  filterDebounceTime          : 500,
  goldenWaitTime              : 1000, // Not sure why we have to wait before the page is ready, but it's the golden rule
  loginCookieName             : 'userarea-logged-in',
  
  // Breakpoints
  breakpoints                 : Breakpoints,
}
